var load_more = {};
load_more.innitial_items_count = 0;
load_more.first_load = true;
load_more.removed_innitial_items = false;
load_more.date = new Date;
load_more.articles;
load_more.limit_to_show = 10;
load_more.limit_load_errors = 12;
load_more.error_count = 0;
load_more.folder = 'articles';

load_more.get_innitial_items_count = function(){
	$('.alpha .item').each(function(){
		load_more.innitial_items_count = load_more.innitial_items_count + 1;
	});
}

//checks if we have enough items, if we don't it calls get_data to get items
//get_data calls this function as soon as it has enough items
load_more.append_items = function(){
	//check how many 404 of json we got
	//if we got too many it checks how many items we have it will either grab the limit_to_show limit and display it
	//or just display whatever the array has, empty the array, hide the button
	if(this.error_count > this.limit_load_errors){
		if(typeof this.articles != 'undefined' && this.articles.length > 0){
			if(this.articles.length > this.limit_to_show){
				var items = this.articles.slice(0, this.limit_to_show);
				this.pappendFeedData(items);
				this.articles = this.articles.slice(this.limit_to_show);
			}else{
				this.pappendFeedData(this.articles);
				this.articles = [];
				$('#load_more_wrapper').hide();
			}
		}else{
			this.articles = [];
			$('#load_more_wrapper').hide();
		}
	}else{
		//else we call get_data if we don't have enough articles
		$('.ajaxRight').show();
		if(typeof this.articles == 'undefined' || this.articles.length < this.limit_to_show){
			this.get_data();
		}else{
			//once we have enough data we push however many limit_to_show is set to
			//and remove the pushed articles from the articles array
			var items = this.articles.slice(0, this.limit_to_show);
			this.pappendFeedData(items);
			this.articles = this.articles.slice(this.limit_to_show);
		}
	}
}

load_more.get_data = function(){

	if(this.removed_innitial_items == false && this.innitial_items_count == 0){
		this.get_innitial_items_count();
	}

	//on first data load we just grab whatever year and month we are on
	if(this.first_load){
		this.year = this.date.getFullYear();
		this.month = this.date.getMonth()+1;
		
		var cache_butst = new Date().getTime();
		var url = window.location.protocol+"//"+window.location.hostname+"/"+this.folder+"/"+this.year+"/"+this.pad(this.month)+"/archive.json?v="+cache_butst;
	}else{
	//else we decrement by one month and grab that json file
		this.date.setMonth(this.date.getMonth()-1);

		this.year = this.date.getFullYear();
		this.month = this.date.getMonth()+1;

		var cache_butst = new Date().getTime();
		var url = window.location.protocol+"//"+window.location.hostname+"/"+this.folder+"/"+this.year+"/"+this.pad(this.month)+"/archive.json?v="+cache_butst;
	}

	$.ajax({
		url: url,
		dataType: 'json',
	  	success:(data) => {
	  		//if the json file has data
	  		if(parseInt(data.feed.num_posts) > 0){
	  			//on first load the array is undefined so we just assign the json feed and it becomes an array
	  			if(typeof load_more.articles == 'undefined'){
	  				load_more.articles = data.feed.item;
	  			}else{
	  				//else we push one by one to the array to keep the keeps in the array good
	  				for(var i in data.feed.item){
	  					load_more.articles.push(data.feed.item[i]);
	  				}	  				
	  			}
	  		}
	  	},
	  	error:function(){
	  		//on json errors we add to the error tracker
	  		load_more.error_count = load_more.error_count + 1;
	  	},
	  	complete:function(){
	  		//if we have the amount to remove and amount to display
	  		//or if we have enough and we have already removed on screen items
	  		//or if we got too many 404s on json file look ups
	  		if( (load_more.removed_innitial_items == false && typeof load_more.articles != 'undefined' && parseInt(load_more.articles.length) >= (load_more.innitial_items_count + load_more.limit_to_show) )
	  			|| (load_more.removed_innitial_items == true && typeof load_more.articles != 'undefined' && parseInt(load_more.articles.length) >= load_more.limit_to_show) 
	  			|| load_more.error_count > load_more.limit_load_errors ){
	  			load_more.first_load = false;
	  			//on first load we remove however many there on the screen from the array
	  			if(!load_more.removed_innitial_items){
	  				load_more.removed_innitial_items = true;
	  				load_more.articles = load_more.articles.slice(load_more.innitial_items_count);
	  			}
	  			//we have enough so we call the append_items function
	  			load_more.append_items();
	  		}else{

	  		//else we run the get_data once again
	  			load_more.first_load = false;
	  			load_more.get_data();
	  		}
	  	}
	});
}

//some ads bring their own pad function
//so I added this to the object
load_more.pad = function(n){
	return (n < 10) ? ("0" + parseInt(n)) : n;
}

load_more.pappendFeedData = function(display_items){
	var tracker = 1;
	
	display_items.sort(function(a,b){ 
	  // Turn your strings into dates, and then subtract them
	  // to get a value that is either negative, positive, or zero.
	  return new Date(a.date) - new Date(b.date);
	});
	
	$.each(display_items, function(i, item) {

		//console.log(item);
		
		var months = Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
		var days =   Array("Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday");

		var itemID = item.id;
		var itemImg = item.image;
		var itemLink = item.link;
		var itemExc = item.excerpt;
		var itemByline = item.byline;
		var author = item.author;
		var postDate = item.postDate;
		var itemTitle = item.title.replace(/&acute;/g, "&#039;");

		var date = new Date(item.date);
		
		var dhtml = "";
		
		dhtml += '<div class="post item" data-id="'+itemID+'" data-year="" data-month="" data-day="">';
			dhtml += '<div class="section-social" data-feed-description="'+itemTitle+'" data-feed-caption="'+itemByline+'">';
				dhtml += '<div class="socialBar" data-style="short" data-dialog="share" data-src-title="'+itemTitle+'" data-src-url="'+itemLink+'"><div class="left toolset"></div></div>';
				dhtml += '<div class="socialBar-clicks"></div>';
				dhtml += '<div class="socialBar-divide"></div>';
				dhtml += '<div class="socialBar-shares"></div>';
			dhtml += '</div>';
	
			dhtml += '<h2 id="article-title"><a href="'+itemLink+'">'+itemTitle+'</a></h2>';
			dhtml += '<p class="author">';
				dhtml += '<strong>'+author+'</strong> - '+ postDate;
			dhtml += '</p>';
			
			dhtml += '<div id="article_body" class="article_body">';
			
				/*dhtml += '<div class="image" style="'.$ae_pic_container_styles.'">';
					dhtml += '<img src="'+itemImg+'" width="100%" />';      
				dhtml += '</div>';*/
				
				//excerpt -- 4 paras
				dhtml += itemExc;
				
				dhtml += '<div class="big_more"><a href="'+itemLink+'">Read Full Story <span>»<span></a></div>';
			
			dhtml += '</div><!-- article_body -->';
		

		
			/*dhtml += "<a href='"+itemLink+"'>" +
				'<div class="vt-bg-item"><img src="'+itemImg+'" /></div>' +
				'<span class="vital-title"><p>'+itemTitle+'</p></span>' +
				'<img class="vs-logo" src="/asset/img/vs-logo.png">' +
			"</a>";*/
		dhtml += '</div> ';

				

		//console.log(dhtml);
		
		$('.more-posts').append(dhtml);	
		//$(".alpha .last").after(dhtml);	
		$('.ajaxRight').hide();
		tracker++; //increase item counter					
	});	
    
    loadSocialTools();
}
//end load more

export default load_more;